// Generated by tools/generate-version.mjs. Do not edit manually.
export const APP_BUILD_VERSION = "20be73cc78f624110f019500d58595b54d58e497";
